import { useState } from 'react';
import userImage from '../../../assets/images/userDemoImg.png';
import Konva from 'konva';
import { useTranslation } from 'react-i18next';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CanvasSide = ({
    currentStage,
    stageProperties,
    selectedShape,
    setStageProperties,
    setFontSize,
    stageFront,
    stageBack,
    setShowResources,
    updateForm,
    setSelectedShape,
    fontSize,
    setShapeHorizontal,
    setShapeVertical,
}) => {
    const { t } = useTranslation();
    const [countertRectangle, setcountertRectangle] = useState(1);
    // Generates a unique ID based on the current time in hexadecimal format.
    function searchId(stringVar) {
        return Date.now().toString(16).slice(-3);
    }
    // Handles the click event on the stage to determine if a shape was clicked.
    const handleStageClick = (e) => {
        const clickedOnShape =
            e.target.attrs.id.includes('squares') ||
            e.target.attrs.id.includes('ellipsis') ||
            e.target.attrs.id.includes('lines') ||
            e.target.attrs.id.includes('texts') ||
            e.target.attrs.id.includes('resources');

        if (!clickedOnShape) {
            setSelectedShape(null);
        }
    };
    // Handles drag-and-drop functionality for shapes onto the stage.
    const handleDrop = (e) => {
        e.preventDefault();
        const buttonType = e.dataTransfer.getData('buttonType');
        const base64 = e.dataTransfer.getData('base64');
        const resourceId = e.dataTransfer.getData('resourceId');
        const attribute = e.dataTransfer.getData('attribute');
        const stage = currentStage === 1 ? stageFront.current : stageBack.current;
        const stagePos = {
            x: e.clientX - stage.container().getBoundingClientRect().left,
            y: e.clientY - stage.container().getBoundingClientRect().top,
        };
        if (stagePos) {
            let shape;
            let property;
            if (buttonType === 'rectangleTemplate') {
                shape = {
                    id: `squares_${searchId()}`,
                    x: Math.round(stagePos.x),
                    y: Math.round(stagePos.y),
                    width: 50,
                    height: 50,
                    type: buttonType,
                    fill: '#146F62',
                    property: 'squares',
                    textName: 'Cuadrado',
                    cornerRadius: 0,
                    stroke: 'black',
                    strokeWidth: 0,
                    skipTransform: true,
                };
                property = 'squares';
                setcountertRectangle(countertRectangle + 1);
            } else if (buttonType === 'ellipseTemplate') {
                shape = {
                    id: `ellipsis_${searchId()}`,
                    x: Math.round(stagePos.x),
                    y: Math.round(stagePos.y),
                    radius: 50,
                    type: buttonType,
                    fill: '#146F62',
                    property: 'ellipsis',
                    textName: `Circulo `,
                    stroke: 'black',
                    strokeWidth: 0,
                };
                property = 'ellipsis';
            } else if (buttonType === 'lineTemplate') {
                shape = {
                    id: `lines_${searchId()}`,
                    x: Math.round(stagePos.x),
                    y: Math.round(stagePos.y),
                    width: 100,
                    height: 5,
                    type: buttonType,
                    fill: '#146F62',
                    property: 'lines',
                    textName: `Línea `,
                    cornerRadius: 0,
                    stroke: 'black',
                    strokeWidth: 0,
                };

                property = 'lines';
            } else if (buttonType === 'textTemplate') {
                shape = {
                    id: `texts_${searchId()}`,
                    x: Math.round(stagePos.x),
                    y: Math.round(stagePos.y),
                    content: 'Your Text Here',
                    fontSize: 30,
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    text: 'centeredScaling = true',
                    textDecoration: 'none',
                    fill: 'blackkkkkkk',
                    type: buttonType,
                    property: 'texts',
                    textName: `Texto `,
                    align: 'center',
                    width: 123,
                    height: 111,
                    allowEdit: true,
                };
                if (attribute) {
                    shape.liveContent = attribute;
                    shape.content = attribute + '*';
                    shape.allowEdit = false;
                }

                property = 'texts';
            } else if (buttonType === 'imageTemplate') {
                shape = {
                    id: `resources_${searchId()}`,
                    x: Math.round(stagePos.x),
                    y: Math.round(stagePos.y),
                    type: buttonType,
                    property: 'resources',
                    textName: `Imagen `,
                    width: 50,
                    height: 50,
                    rotation: 0,
                    base64: base64,
                    resourceId: resourceId,
                };

                if (attribute) {
                    shape.liveContent = attribute;
                    shape.base64 = userImage;
                }

                property = 'resources';
            }

            updateStageProperties(shape, property);
            setSelectedShape(shape);
            updateForm(shape);
            setShowResources(false);
        }
    };
    // Updates the properties of shapes on the stage (position, size, etc.).
    const updateStageProperties = (shape, property, index = undefined, x = undefined, y = undefined) => {
        if (shape === undefined) {
            setShowResources(true);
            return;
        }
        setFontSize(fontSize);
        setShapeVertical(y);
        setShapeHorizontal(x);
        setStageProperties((prevProperties) => {
            const currentProperties = prevProperties[currentStage];
            const updatedShapes = [...currentProperties[property]];
            let updatedCombinedObject;

            if (index !== undefined) {
                updatedShapes[index] = { ...updatedShapes[index], x, y };
                updatedCombinedObject = currentProperties.combinedObject.map((item) => {
                    if (item?.id === (shape?.id || (selectedShape && selectedShape.id))) {
                        return { ...item, x, y };
                    }

                    return item;
                });
            } else {
                if (shape?.id) {
                    updatedShapes.push(shape);
                    updatedCombinedObject = currentProperties.combinedObject.concat(shape);
                }
            }
            return {
                ...prevProperties,
                [currentStage]: {
                    ...currentProperties,
                    [property]: updatedShapes,
                    combinedObject: updatedCombinedObject,
                },
            };
        });
    };
    // Handles the movement of a shape on the stage while it's being dragged.
    const handleDragMove = (e, index) => {
        if (selectedShape !== null) {
            const { width, height } = stageProperties[currentStage];
            const shape = e.target;

            const stage = currentStage === 1 ? stageFront.current : stageBack.current;

            if (shape instanceof Konva.Circle) {
                const shapeClientRect = shape.getClientRect();
                const radiusX = shapeClientRect.radiusX || shapeClientRect.width / 2;
                const radiusY = shapeClientRect.radiusY || shapeClientRect.height / 2;

                let centerX = shape.x() + radiusX;
                let centerY = shape.y() + radiusY;

                let x = shape.x();
                let y = shape.y();

                updateStageProperties(selectedShape, selectedShape?.property, index, x, y);
                shape.position({ x, y });
                stage.batchDraw();
            } else {
                const shapeClientRect = shape.getClientRect();
                const radiusX = shapeClientRect.radiusX || shapeClientRect.width / 2;
                const radiusY = shapeClientRect.radiusY || shapeClientRect.height / 2;

                let centerX = shape.x() + radiusX;
                let centerY = shape.y() + radiusY;

                let x = shape.x();
                let y = shape.y();

                x = Math.round(x);
                y = Math.round(y);
                x = Math.max(0, Math.min(x, width - shapeClientRect.width));
                y = Math.max(0, Math.min(y, height - shapeClientRect.height));

                x = Math.round(x);
                y = Math.round(y);

                updateStageProperties(selectedShape, selectedShape?.property, index, x, y);

                if (x < 0) {
                    x = 0;
                }

                if (y < 0) {
                    y = 0;
                }

                if (x + shapeClientRect.width > width) {
                    x = width - shapeClientRect.width;
                }

                if (y + shapeClientRect.height > height) {
                    y = height - shapeClientRect.height;
                }

                shape.position({ x, y });
                stage.batchDraw();
            }
        }
    };
    return { searchId, handleStageClick, handleDrop, updateStageProperties, handleDragMove };
};
export default CanvasSide;
